<template>
  <div class="help-reviews">
    <div class="content" @scroll="handleScroll" id="reviews">
      <div class="html-reviews" v-html="html" ref="html" v-resize="changeViewsDom"></div>
    </div>
    <Catalog :toc="toc" :activeIndex="activeIndex" @select="scrollToHeading"></Catalog>
  </div>
</template>
<script>
import Catalog from '../components/catalog'
import elementResizeDetectorMaker from "element-resize-detector";
export default {
  components: {
    Catalog
  },
  props: {
    html: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      toc: [],
      activeIndex: -1,
      reviewsDom: '',
      isCheck: false,
      erd: null
    }
  },
  directives:{
    //5、自定义指令监听某标签宽高变化
    resize:{
      bind(el,binding){
        let height= 0
        function isResize(){
          let offsetHeight = el.offsetHeight
          if(height !== offsetHeight){
            binding.value()
          }
          height = offsetHeight
        }
        el._vueSetInterval = setInterval(isResize,300);
      },
      unbind(el){
        clearInterval(el._vueSetInterval)
      }
    }
  },
  watch: {
    html: {
      handler() {
        this.$nextTick(() => {
          this.reviewsDom = document.getElementById('reviews')
          if(!this.reviewsDom) return
          this.reviewsDom.scrollTop = 0
          this.activeIndex = -1
        })
      },
      immediate:true
    },
  },
  mounted() {
  },
  methods: {
    changeViewsDom() {
      this.generateToc()
      this.handleScroll()
    },
    generateToc() {
      const headings = this.reviewsDom.querySelectorAll( 'h1, h2, h3, h4 ,h5, h6' )
      this.toc = Array.from(headings).map((heading, index) => {
        let reg = /[1-9][0-9]*/g
        return {
          text: heading.textContent,
          topOffset: heading.offsetTop,
          type: 'header' + heading.tagName.match(reg)[0],
          id: index
        }
      })
    },
    scrollToHeading(index) {
      const heading = this.reviewsDom.querySelectorAll( 'h1, h2, h3, h4, h5, h6')[index]
      if (heading) heading.scrollIntoView({ behavior: 'smooth' })
    },
    handleScroll() {
      let scrollTop = this.reviewsDom.scrollTop + this.reviewsDom.offsetTop
      for (let i = this.toc.length - 1; i >= 0; i--) {
        if (scrollTop >= this.toc[i].topOffset) {
          this.activeIndex = i
          break
        }
      }
    },
  }
}
</script>
<style lang="scss">
.help-reviews {
  display: flex;
  height: 100%;
  box-sizing: border-box;
  .content {
    overflow-x: hidden;
    overflow-y: overlay;
    line-height: 1.3;
    width: 0;
    flex: 1;
    display: flex;
    justify-content: center;
    padding-top: 20px;
    .html-reviews {
      width: 960px;
      display: inline-table;
      padding-bottom: 30%;
      a {
        text-decoration: underline !important;
        cursor: pointer;
      }
      img, video {
        max-width: 100%;
      }
      ol, ul {
        list-style: inside;
      }
      h1,h2,h3,h4,h5,h6 {
        font-weight: bold;
      }
    }
  }
}
</style>
